var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-info",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.926,
    height: 22.925,
    viewBox: "0 0 22.926 22.925",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M11.463,0A11.463,11.463,0,1,0,22.925,11.463,11.476,11.476,0,0,0,11.463,0Zm0,20.841a9.379,9.379,0,1,1,9.379-9.378A9.389,9.389,0,0,1,11.463,20.841Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M146.391,70a1.389,1.389,0,1,0,1.389,1.39A1.391,1.391,0,0,0,146.391,70Z",
    transform: "translate(-134.929 -65.137)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M151.042,140A1.042,1.042,0,0,0,150,141.042v6.252a1.042,1.042,0,1,0,2.084,0v-6.252A1.042,1.042,0,0,0,151.042,140Z",
    transform: "translate(-139.579 -130.274)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.1f43e7b5.svg";
export { ForwardRef as ReactComponent };